import * as Yup from 'yup';

import { FIELD_IS_REQUIRED } from 'src/common/validation/errors';
import type { ICustomerLeadProductPurchaseProductTypesTabFormValues } from 'src/components/customers/CustomerLeadTypes';
import type { ICustomerLeadProduct } from 'src/types/customers/ICustomerLeadProduct';

export const customerLeadProductAdditionalInformationValidationSchema =
  Yup.object<ICustomerLeadProductPurchaseProductTypesTabFormValues>().shape({
    purchaseProductTypes: Yup.array().of(Yup.string().required(FIELD_IS_REQUIRED)).nullable().default(null),
    customerPickup: Yup.boolean().nullable().default(null),
  });

export const customerLeadProductAdditionalInformationInitialValues = (
  customerLeadProduct?: ICustomerLeadProduct
): ICustomerLeadProductPurchaseProductTypesTabFormValues => ({
  purchaseProductTypes: customerLeadProduct?.purchaseProductTypes ?? [],
  customerPickup: customerLeadProduct?.customerPickup ?? null,
});
